// T240 (3 Oct 2026), Natanel: "when it asks for a yes or no, it should give a yes or no button as
// an option for mona and i to press so we dont need to write yes or no". In the brain's chat a card
// has its own Confirm and Dismiss and an import its own Import, so the two buttons go only under an
// answer that asks a yes or a no of its own and puts up neither (app/VeraPanel.tsx, the newest
// answer alone). Since T373c (18 Oct 2026) the model says whether it asked one (`asksYesNo`, the
// find's `asks_yes_no`); code no longer reads the words.

// T429 (23 Oct 2026): an unclear ask is put as its readings (`options`, the find's), a button
// each, and a tap sends its label as the next question. They replace Yes and No, never sit with them.

// T453 (24 Oct 2026): as many readings as the question truly has, no cap. When the model says they can
// go together (`pickSeveral`), each is a tick and one Send asks the ticked ones, joined (`joinPicked`, `@vera/db/picked-options` since T453a).

/**
 * T429e: only a card still waiting for a tap has its own Confirm; one applied at once (T429) leaves
 * the answer free to ask its own yes or no.
 */
const awaitsATap = (turn: { actions: readonly { status?: string }[] }): boolean =>
  turn.actions.some((card) => card.status === 'proposed');

/** The readings to put as buttons under an answer: all of them, none when it put up a card or a preview. */
export function optionsUnder(
  turn: {
    answer: string | null;
    options?: readonly string[];
    actions: readonly { status?: string }[];
  },
  previews: number,
): string[] {
  if (turn.answer === null || awaitsATap(turn) || previews > 0) return [];
  return [...(turn.options ?? [])];
}

export function yesNoUnder(
  turn: {
    answer: string | null;
    asksYesNo?: boolean;
    options?: readonly string[];
    actions: readonly { status?: string }[];
  },
  previews: number,
): boolean {
  return (
    turn.answer !== null &&
    turn.asksYesNo === true &&
    !awaitsATap(turn) &&
    previews === 0 &&
    optionsUnder(turn, previews).length === 0
  );
}
